import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
import TeamAuth from "./pages/TeamAuth.jsx";
import TeamConfirmation from "./pages/TeamConfirmation";
import CoachDashboard from "./pages/CoachDashboard.jsx";
import Payment from "./pages/Payment.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import AddPlayer from "./pages/AddPlayer.jsx";
import AdminLogin from "./pages/AdminLogin.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import Rules from "./pages/Rules";
import Help from "./pages/Help";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<TeamAuth />} />
        <Route path="/confirm" element={<TeamConfirmation />} />
        <Route path="/coach" element={<CoachDashboard />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/add-player" element={<AddPlayer />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/help" element={<Help />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
